import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Akanksha Rani </span>
            from <span className="purple"> New Delhi, India.</span>
            <br />| Software Developer | AI ML Enthusiast | Open Source Contributor |
            <br />
            <br />
            Over the past few years, I’ve had the opportunity to work at top tech giants- Amazon, Microsoft, and the Linux Foundation, where I worked on multiple full stack and backend projects.
. Apart from coding, some other activities that I love to do !
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Mentoring
            </li>
            <li className="about-activity">
              <ImPointRight /> Dancing 
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Build your own Empire before you start building for someone else's!"{" "}
          </p>
          <footer className="blockquote-footer">Akanksha </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
